import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import map from 'lodash/map';
import DataProvider from 'api/data-provider';
import Block, { BlockHeader, BlockContent } from 'components/block';
import Link from 'components/link';
import linksForum from 'src-sites/forum/links';

const bemClassesLinkList = new Bem('linkListItem');

export default class ContextBlock extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    forum_id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    block_number: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ])
  };

  /**
   * Get context block data.
   */
  getData(val = {}, block_number) {
    const data = (val.data && val.data[0]) ? val.data[0] : null;

    if (!data || !data.context || !data.published) return null;

    return (
      <Block>
        <BlockHeader headerTopic={<h2>Сейчас обсуждают {block_number}</h2>} />
        <BlockContent>
          {map(data.context, (item, index) => this.showTopics(item.forum_topics, `context-forum-${index}`))}
        </BlockContent>
      </Block>
    );
  }

  /**
   * Show topics data.
   */
  showTopics(topics = {}, index) {
    if (!topics) return null;

    return map(topics, item => (
      <div
        key={`context-${item.topic_id}-${index}`}
        {...bemClassesLinkList({ extra: this.props.className })}
      >
        <Link
          {...bemClassesLinkList('link')}
          builder={linksForum.sectionTopic}
          builderProps={item}
        >
          <span {...bemClassesLinkList('linkContent')}>
            <span {...bemClassesLinkList('text')}>{item.topic_title}</span>
          </span>
        </Link>
      </div>
    ));
  }

  render() {
    const { forum_id, block_number } = this.props;
    if (!forum_id) return null;

    return (
      <DataProvider
        updateEvent="updateContext"
        url="forum/context-blocks"
        query={{
          'block-number': block_number,
          'forum-id': forum_id
        }}
        renderer={data => this.getData(data, block_number)}
      />
    );
  }
}
